import { render, staticRenderFns } from "./roleUserTable.vue?vue&type=template&id=1fabc55e&scoped=true&"
import script from "./roleUserTable.vue?vue&type=script&lang=js&"
export * from "./roleUserTable.vue?vue&type=script&lang=js&"
import style0 from "./roleUserTable.vue?vue&type=style&index=0&id=1fabc55e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fabc55e",
  null
  
)

export default component.exports